import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ILooseObject } from '@/src/types/common.interface';

type AppConfigDataState = {
  selectedTabValue?: number;
};

const initialState: AppConfigDataState = {};

const appConfigData = createSlice({
  name: 'appConfigData',
  initialState,
  reducers: {
    saveAppConfigData: (state, action: PayloadAction<ILooseObject>) => {
      return { ...state, ...action.payload };
    },
    clearAppConfigData: () => {
      return {}; // Reset state to an empty object
    }
  }
});

export const { saveAppConfigData, clearAppConfigData } = appConfigData.actions;
export default appConfigData.reducer;
